import { Property, PropertyId } from '../types/booking'

export const properties: Property[] = [
  {
    id: 'APT3-01',
    name: 'Three-Bedroom Apartment',
    shortName: '3-Bedroom',
    bedrooms: 3,
    maxGuests: 10,
    nightlyRate: 220000,
    tagline: 'Room for the whole group, the whole shoot, the whole weekend',
    description:
      'Our largest apartment — three bedrooms, generous shared living space and direct access to the pool. The natural choice for friend groups, families and productions that need room to move.',
    amenities: ['Swimming pool', 'Generator-backed power', '24-hour internet'],
    images: [
      {
        src: 'https://cdn.magicpatterns.com/patterns/generated-images/a1147893-9c81-497e-b832-78281b5e8175.jpg',
        alt: 'Placeholder photo: living room of the three-bedroom apartment',
      },
      {
        src: 'https://cdn.magicpatterns.com/patterns/generated-images/b0b77788-0bac-4444-a9d2-1657d0af40fb.jpg',
        alt: 'Placeholder photo: bedroom with cream linen bedding',
      },
      {
        src: 'https://cdn.magicpatterns.com/patterns/generated-images/984178c3-8e5b-4319-a7a8-a7735c9dafc4.jpg',
        alt: 'Placeholder photo: open-plan kitchen and dining area',
      },
    ],
  },
  {
    id: 'APT2-01',
    name: 'Two-Bedroom Apartment',
    shortName: '2-Bedroom',
    bedrooms: 2,
    maxGuests: 7,
    nightlyRate: 180000,
    tagline: 'Composed and quiet, for couples, small families and creators',
    description:
      'Two bedrooms and a calm living area, with the same pool, power and internet as the rest of the property. Ideal for getaways, honeymoons and focused content days.',
    amenities: ['Swimming pool', 'Generator-backed power', '24-hour internet'],
    images: [
      {
        src: 'https://cdn.magicpatterns.com/patterns/generated-images/66640e95-349d-4590-91ba-aa1b0338e1f9.jpg',
        alt: 'Placeholder photo: living area of the two-bedroom apartment',
      },
      {
        src: 'https://cdn.magicpatterns.com/patterns/generated-images/b0b77788-0bac-4444-a9d2-1657d0af40fb.jpg',
        alt: 'Placeholder photo: bedroom with warm reading lights',
      },
      {
        src: 'https://cdn.magicpatterns.com/patterns/generated-images/de45ff2e-59c3-498e-ab11-27d11505d111.jpg',
        alt: 'Placeholder photo: pool deck with loungers',
      },
    ],
  },
]

/** Shown under each property's amenity list until the full list is confirmed. */
export const AMENITIES_PLACEHOLDER = 'Full amenity list to be confirmed'

export const fees = {
  cautionFee: 100000,
  earlyLateMin: 70000,
  earlyLateMax: 100000,
  photoshootSession: 100000,
  photoshootHours: 3,
  photoshootMaxGuests: 10,
}

export const stayTimes = {
  checkIn: '2:00 PM',
  checkOut: '12:00 noon',
}

/** Photoshoot start times offered (24h). Sessions end 3 hours later. */
export const photoshootStartTimes = ['08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00']

export function getProperty(id: string): Property {
  return properties.find((property) => property.id === id) ?? properties[0]
}

export function isPropertyId(value: string | null): value is PropertyId {
  return properties.some((property) => property.id === value)
}
